import WarningIcon from "@mui/icons-material/Warning";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { misc } from "app/themes/colors";

type ErrorSnackbarContentProps = {
  title?: string;
  content?: string | React.ReactNode;
};

export default function WarningSnackbarContent({
  title = "Warning",
  content
}: ErrorSnackbarContentProps) {
  return (
    <Stack spacing={1}>
      {Boolean(title) && (
        <Stack direction="row" alignItems="center" spacing={1}>
          <WarningIcon sx={{ fontSize: "22px", color: misc.warningText }} />
          <Typography
            fontWeight={700}
            fontSize="16px"
            color={misc.warningText}
            sx={{ pb: 0.3 }}
          >
            {title}
          </Typography>
        </Stack>
      )}
      {Boolean(content) && typeof content === "string" ? (
        <Typography fontWeight={400} color={misc.warningText}>
          {content}
        </Typography>
      ) : Boolean(content) ? (
        content
      ) : null}
    </Stack>
  );
}
